import React, { createContext, useContext, useState } from 'react';

const DemoModalContext = createContext();

export const useDemoModal = () => {
  const context = useContext(DemoModalContext);
  if (!context) {
    throw new Error('useDemoModal must be used within DemoModalProvider');
  }
  return context;
};

export const DemoModalProvider = ({ children }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState('');

  const openModal = (language = '') => {
    setSelectedLanguage(language);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedLanguage('');
  };

  return (
    <DemoModalContext.Provider value={{ isModalOpen, selectedLanguage, openModal, closeModal }}>
      {children}
    </DemoModalContext.Provider>
  );
};
